import { Button } from 'palette/Button';
import { BodyText, Header } from 'palette/Typography';
import { BEMBlock } from '@helpers/classnames';
import '../styles/GlobalSearchHeader.scss';

interface GlobalSearchHeaderProps {
    hasButton?: boolean;
    buttonLabel?: string;
    title: string;
    onClick?: () => void;
}

function GlobalSearchHeader({
    hasButton, buttonLabel, title, onClick,
}: GlobalSearchHeaderProps) {
    const [block, BEMElement] = BEMBlock('global-search-header');

    return (
        <div className={block}>
            <Header
                level="5"
            >
                {title}
            </Header>
            {hasButton && (
                <Button
                    isTransparent
                    className={BEMElement('button')}
                    theme="secondary"
                    onClick={onClick}
                >
                    <BodyText
                        color="attention"
                        level="2"
                    >
                        {buttonLabel}
                    </BodyText>
                </Button>
            )}
        </div>
    );
}

export default GlobalSearchHeader;
